import { CheckCircle2, GraduationCap, Award, Users, ShieldCheck } from "lucide-react";
import { BRAND, OWNER, CITY, CONTACT_EMAIL } from "@/lib/constants";
import { useSEO } from "@/lib/useSEO";

const STUDENTS = "https://images.pexels.com/photos/7616700/pexels-photo-7616700.jpeg";

export default function About() {
  useSEO({
    title: "About ScholarPrintHub — Owner-operated by Suraj Dubey, Lucknow",
    description: "Learn about ScholarPrintHub — the one-stop academic services and printing platform owner-operated by Suraj Dubey from Lucknow. 500+ scholars supported since 2020.",
    keywords: "about scholarprinthub, suraj dubey lucknow, thesis printing owner, academic services founder",
  });
  return (
    <div data-testid="about-page" className="container-app py-16">
      <span className="section-eyebrow">About</span>
      <div className="divider-gold mt-2 mb-4" />
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-7">
          <h1 className="font-display text-4xl sm:text-5xl text-navy">The full-stack academic partner for Indian scholars.</h1>
          <p className="mt-6 text-slate-600 text-base">
            {BRAND} was created to solve one persistent problem: <em>every Ph.D. scholar or postgraduate student runs across five or six different vendors — writer, editor, plagiarism-check portal, printer, bookbinder, courier</em>. We unify the entire workflow so you can focus on your research.
          </p>
          <p className="mt-4 text-slate-600 text-sm">
            Based in {CITY}, we&apos;ve helped hundreds of nursing, medical, law, management, and engineering students with editing, formatting, plagiarism review, printing, and hard-bound thesis delivery.
          </p>

          <div className="grid sm:grid-cols-2 gap-4 mt-10">
            {[
              [GraduationCap, "500+ scholars supported", "From Ph.D. to college assignments"],
              [Award, "Golden embossed thesis", "Premium binding & spine printing"],
              [Users, "Multidisciplinary team", "Editors, formatters, printers"],
              [ShieldCheck, "Confidential handling", "Files are never shared with third parties"],
            ].map(([Icon, t, d], i) => (
              <div key={i} className="border border-slate-200 rounded-sm p-4">
                <Icon className="w-5 h-5 text-gold" />
                <div className="font-medium text-navy mt-3 text-sm">{t}</div>
                <div className="text-xs text-slate-500 mt-1">{d}</div>
              </div>
            ))}
          </div>

          <div className="mt-10 border border-slate-200 rounded-sm p-6 bg-slate-50">
            <div className="section-eyebrow">Ethical positioning</div>
            <p className="mt-2 text-sm text-slate-700">
              Our services are intended for academic support, editing, formatting, research guidance,
              citation correction, plagiarism checking, and document preparation. Customers are responsible for using
              the final material according to their institution&apos;s academic policies.
            </p>
          </div>
        </div>

        <aside className="lg:col-span-5 space-y-6">
          <div className="border border-slate-200 rounded-sm overflow-hidden">
            <img src={STUDENTS} alt="Students collaborating" className="w-full h-72 object-cover" />
          </div>
          <div className="border border-slate-200 rounded-sm p-6">
            <div className="section-eyebrow">Founder</div>
            <div className="font-display text-3xl mt-2 text-navy">{OWNER}</div>
            <div className="text-sm text-slate-600 mt-1">@surajdubeyks · {CITY}</div>
            <div className="text-xs text-slate-500 mt-2">{CONTACT_EMAIL}</div>
            <ul className="mt-4 space-y-2 text-sm text-slate-700">
              {["Runs the day-to-day operations", "Handles proof approval and print QC", "Talks to every customer personally"].map((t, i) => (
                <li key={i} className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-gold shrink-0 mt-0.5" /><span>{t}</span></li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
}
